import { dew as _ListSheetsResponseDew } from "./ListSheetsResponse";
import { dew as _SheetResponseDew } from "./SheetResponse";
import { dew as _SheetDew } from "./Sheet";
import { dew as _SheetConfigDew } from "./SheetConfig";
import { dew as _SheetConfigUpdateDew } from "./SheetConfigUpdate";
import { dew as _SheetUpdateDew } from "./SheetUpdate";
import { dew as _SheetConfigOrUpdateDew } from "./SheetConfigOrUpdate";
import { dew as _RecordCountsResponseDew } from "./RecordCountsResponse";
import { dew as _RecordCountsResponseDataDew } from "./RecordCountsResponseData";
import { dew as _FieldConfigResponseDew } from "./FieldConfigResponse";
import { dew as _SheetAccessDew } from "./SheetAccess";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_ListSheetsResponseDew(), exports);
  __exportStar(_SheetResponseDew(), exports);
  __exportStar(_SheetDew(), exports);
  __exportStar(_SheetConfigDew(), exports);
  __exportStar(_SheetConfigUpdateDew(), exports);
  __exportStar(_SheetUpdateDew(), exports);
  __exportStar(_SheetConfigOrUpdateDew(), exports);
  __exportStar(_RecordCountsResponseDew(), exports);
  __exportStar(_RecordCountsResponseDataDew(), exports);
  __exportStar(_FieldConfigResponseDew(), exports);
  __exportStar(_SheetAccessDew(), exports);
  return exports;
}